import type { ListPageExcelOptions } from './editor-model';
import { importListPageWorkbook } from './workbook';

export type ListPageEditorFileResult =
  | { status: 'invalid-template' }
  | { status: 'ready'; rows: unknown[][]; message?: string };

export const readListPageEditorFile = async (
  file: File,
  options: ListPageExcelOptions,
): Promise<ListPageEditorFileResult> => {
  const result = await importListPageWorkbook(file, options);
  if (result.status === 'invalid-template') return result;
  return {
    status: 'ready',
    rows: result.rows ?? [],
    message:
      result.status === 'invalid'
        ? `${result.errorCount} validation error${result.errorCount === 1 ? '' : 's'} found. Fix the red cells before saving.`
        : undefined,
  };
};
